import {
  Select,
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@volca/ui/components/ui/select";
import { dayjs } from "@volca/ui/lib/date";
import { cn } from "@volca/ui/lib/utils";

const getLastMonthLabel = () => {
  const lastMonth = dayjs().subtract(1, "month");
  const monthName = lastMonth.format("MMM");
  return `Last month (${monthName})`;
};

export const FILTER_OPTIONS = [
  { label: "Last 30 days", value: "last_thirty_days" },
  { label: getLastMonthLabel(), value: "last_month" },
  { label: "All time", value: "all_time" },
] as const;

export type TimeframeValue = (typeof FILTER_OPTIONS)[number]["value"];

interface TimeframeFilterProps {
  className?: string;
  value: TimeframeValue;
  onChange: (value: TimeframeValue) => void;
  "aria-label"?: string;
}

export const TimeframeFilter = ({
  className,
  value,
  onChange,
  "aria-label": ariaLabel = "Time frame",
}: TimeframeFilterProps) => (
  <Select
    value={value}
    onValueChange={(next) => {
      if (next) onChange(next);
    }}
    items={FILTER_OPTIONS}
  >
    <SelectTrigger
      aria-label={`${ariaLabel}: ${FILTER_OPTIONS.find((option) => option.value === value)?.label ?? "none"}`}
      className={cn("w-50", className)}
    >
      <SelectValue placeholder="Select timeframe" />
    </SelectTrigger>
    <SelectContent>
      <SelectGroup>
        {FILTER_OPTIONS.map((option) => (
          <SelectItem key={option.value} value={option.value}>
            {option.label}
          </SelectItem>
        ))}
      </SelectGroup>
    </SelectContent>
  </Select>
);
